import { render, staticRenderFns } from "./BusinessDashboardStatistics.vue?vue&type=template&id=fb8195e6&scoped=true&"
import script from "./BusinessDashboardStatistics.vue?vue&type=script&lang=js&"
export * from "./BusinessDashboardStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb8195e6",
  null
  
)

export default component.exports